var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:'video_' + _vm.hisIndex,attrs:{"src":_vm.src,"controls":"","autoplay":""},on:{"timeupdate":_vm.videoTimeUpdate,"ended":_vm.videoEnded}})}
var staticRenderFns = []

export { render, staticRenderFns }